
































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getCurrentTime } from "@/utils/base";
import {
  addRecords,
  editRecords,
  getRecords,
  getConsultationHistory,
} from "@/request/custom";
import { UploadFile } from "@/components/template-transfer-pc/template-transfer/request";
import DsCarousel from "@/components/ds-carousel/ds-carousel.vue";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
@Component({
  components: {
    DsCarousel,
    LeaveConfirm,
  },
})
export default class Name extends Vue {
  @Prop()
  private routerPath: any; // 页面要跳转的路由
  @Prop()
  private leaveType: any; // 离开，下一步，切换
  @Prop()
  private leavePath: any;
  @Prop()
  private changeData: any; // 评估未保存，确认保存会用到
  @Prop()
  private pageSource: any;
  @Prop()
  private pingguData: any;
  @Prop()
  private assess_id: any;
  @Prop()
  private noSaveText: any;
  @Prop()
  private ifShow: any;
  @Watch("ifShow", { immediate: true })
  private ifShowChange() {
    this.ifShowSaveConfirm = this.ifShow;
  }
  @Prop()
  private id: any;
  @Watch("id", { immediate: true })
  private idChange() {
    if (this.pageSource !== "评估") {
      this.resetData();
    }
  }
  @Prop()
  private refreshDataTime: any;
  @Watch("refreshDataTime", { immediate: true })
  private refreshDataTimeChange() {
    if (
      this.refreshDataTime &&
      this.pageSource == "评估" &&
      this.pingguData["类别"] == "checkup"
    ) {
      this.resetData();
    }
  }
  private ifShowSaveConfirm: any = false;
  private detail: any = {};
  private queryData: any = {};
  private ifShowTongbu: any = false;
  private selectVal: any = {};
  private tongbuList: any = [];
  private disabledDate: any = this.endDate();
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private delImg(index: any) {
    this.$confirm("确定要删除吗？", "删除", {
      customClass: "commonConfirm",
    })
      .then(() => {
        this.detail.pic_list.splice(index, 1);
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private preview(item: any) {
    window.open(item.url);
  }
  private openTongbu() {
    this.selectVal = {};
    this.getHistoryData();
    this.ifShowTongbu = true;
  }
  private tongbu() {
    if (!this.selectVal.inspect_id) {
      this.$message.warning("请选择需要同步的记录");
      return;
    }
    this.detail.inspect_info = this.selectVal.inspect_info;
    this.detail.ocr_origin = this.selectVal.ocr_origin;
    this.detail.pic_list = this.selectVal.pic_list;
    this.detail.content = this.selectVal.content;
    this.ifShowTongbu = false;
  }
  private getHistoryData() {
    const params: any = {
      params: {
        patient_id: this.patient.patient_id,
        type: this.pingguData.inspect_name,
      },
    };
    getConsultationHistory(this, params).then((res: any) => {
      this.tongbuList = res;
    });
  }
  private cancel() {
    this.$emit("cancel");
  }
  private goHome() {
    this.$router.push("/main/workstation/patient-file");
  }
  private edit() {
    this.$store.commit("updateIfCompose", true);
  }
  private del(i: any) {
    this.detail.pic_list.splice(i, 1);
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  // 保存确认弹框保存
  private changeSave() {
    this.cancel();
    this.save().then(() => {
      if (this.leaveType == "切换") {
        this.$emit("changeTab", this.changeData);
      } else if (this.leaveType == "下一步") {
        this.$emit("goReport");
      } else {
        if (this.routerPath == "/login") {
          this.$store.commit("updateToken", "");
          this.$store.commit("updateUser", null);
          this.$router.replace("/login");
          setTimeout(() => {
            location.reload();
          }, 1000);
        } else {
          this.$router.push(this.routerPath);
        }
      }
    });
  }
  // 保存确认弹框不保存,切换
  private changeConfirmed() {
    this.cancel();
    this.$store.commit("updateIfCompose", false);
    if (this.leaveType == "切换") {
      this.$emit("changeTab", this.changeData);
    } else if (this.leaveType == "下一步") {
      this.$emit("goReport");
    } else {
      if (this.routerPath == "/login") {
        this.$store.commit("updateToken", "");
        this.$store.commit("updateUser", null);
        this.$router.replace("/login");
        setTimeout(() => {
          location.reload();
        }, 1000);
      } else {
        this.$router.push(this.routerPath);
      }
    }
  }
  /**
   * @description 列表上传文档
   */
  private uploadFile(d: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const fileObj = d.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    UploadFile(this, form)
      .then((data: any) => {
        loading.close();
        const arr: any = d.file.name.split(".");
        const nameArr = arr.slice(0, -1);
        const obj = {
          name: nameArr.join("."),
          type: arr[arr.length - 1],
          url: data.full_file_url,
        };
        this.detail.pic_list.push(obj);
      })
      .catch(() => {
        loading.close();
      });
  }
  private getDetail() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        inspect_type: "checkup",
        patient_id: this.patient.patient_id,
        inspect_id: this.detail.inspect_id,
      },
    };
    getRecords(this, params)
      .then((res: any) => {
        loading.close();
        this.detail = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private save() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      if (this.detail.inspect_id) {
        const params: any = {
          assess_id: this.assess_id ? this.assess_id : this.detail.assess_id,
          inspect_id: this.detail.inspect_id,
          patient_id: this.patient.patient_id,
          inspect_time: this.detail.inspect_time,
          inspect_type: "checkup",
          pic_list: this.detail.pic_list,
          inspect_info: this.detail.inspect_info,
        };
        editRecords(this, params)
          .then((res: any) => {
            loading.close();
            this.$store.commit("updateIfCompose", false);
            this.$message.success("保存成功");
            if (this.pageSource == "评估" && this.leaveType != "切换") {
              this.$emit("refresh");
            } else if (this.pageSource != "评估") {
              this.detail = res;
              this.getDetail();
            }
            resolve(true);
          })
          .catch(() => {
            loading.close();
          });
      } else {
        const params: any = {
          assess_id: this.assess_id ? this.assess_id : this.detail.assess_id,
          temp_id: this.detail.temp_id,
          patient_id: this.patient.patient_id,
          inspect_time: this.detail.inspect_time,
          inspect_type: "checkup",
          pic_list: this.detail.pic_list,
          inspect_info: this.detail.inspect_info,
        };
        addRecords(this, params)
          .then((res: any) => {
            loading.close();
            this.$store.commit("updateIfCompose", false);
            this.$message.success("保存成功");
            if (this.pageSource == "评估" && this.leaveType != "切换") {
              this.$emit("refresh");
            } else if (this.pageSource != "评估") {
              this.detail = res;
              this.getDetail();
            }
            resolve(true);
          })
          .catch(() => {
            loading.close();
          });
      }
    });
  }
  private resetData() {
    if (this.id) {
      this.detail.inspect_id = this.id;
      this.getDetail();
    } else {
      if (!this.queryData.temp_id && !this.pingguData.temp_id) {
        return;
      }
      this.detail = {
        pic_list: [],
        temp_id: this.queryData.temp_id
          ? this.queryData.temp_id
          : this.pingguData.temp_id,
        inspect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
        inspect_name: this.queryData.inspect_name
          ? this.queryData.inspect_name
          : this.pingguData.inspect_name,
        inspect_info: {
          inspect_see: "",
          inspect_position: "",
          inspect_result: "",
          inspect_category: "",
        },
      };
      this.forceUpdate();
    }
  }
  private mounted() {
    if (this.$route.query.data) {
      this.queryData = JSON.parse(this.$route.query.data as any);
    }
    this.resetData();
  }
}
